import * as React from 'react';

import { Button } from '@travelnest/merlin.button';

interface IFrameProps extends React.PropsWithChildren {
	onExit: () => any;
}

export const AdminFrame: React.FC<IFrameProps> = ({ children, onExit }) => {
	return <div className="frame">
		<header className="frame__header">
			Travelnest Admin Portal
			<Button onClick={(e) => { onExit(); e.preventDefault(); }}>Exit customer view</Button>
		</header>
		{children}
	</div>;
};
